/* Scroll reveal: one IntersectionObserver for all [data-reveal] elements. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('js-motion');

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function observe(scope) {
    scope.querySelectorAll('[data-reveal-stagger]').forEach((container) => {
      container.querySelectorAll('[data-reveal]').forEach((el, i) => {
        el.style.setProperty('--reveal-delay', `${i * 80}ms`);
      });
    });
    scope.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => {
      // Elements already in the first viewport reveal instantly: hiding them
      // until this (deferred) script runs would make their late fade-in the
      // page's LCP candidate. Only below-fold elements animate on scroll.
      const rect = el.getBoundingClientRect();
      if (window.scrollY === 0 && rect.top < window.innerHeight) {
        el.style.setProperty('--reveal-delay', '0ms');
        el.classList.add('is-revealed');
        return;
      }
      io.observe(el);
    });
  }

  observe(document);
  // Theme editor remounts sections; re-observe on section load.
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();

/* Image pre-warmer: native lazy loading fetches too close to the viewport, so
   below-fold images visibly pop in while scrolling. Flip to eager once within
   ~1200px so they finish before they're seen; far-off images still defer. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const warm = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.loading = 'eager';
        warm.unobserve(entry.target);
      });
    },
    { rootMargin: '1200px 0px 1200px 0px' }
  );
  const scan = (scope) => {
    scope.querySelectorAll('img[loading="lazy"]').forEach((img) => warm.observe(img));
  };
  scan(document);
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
